class InventoryNotice extends HTMLElement {
  constructor() {
    super();
    this.variantSelector = document.querySelector('select[name="id"]') || document.querySelector('input[name="id"]');
    if (this.variantSelector) {
      this.variantSelector.addEventListener('change', this.onVariantChange.bind(this));
    }
    
    // Initial update
    this.updateInventory();
  }

  onVariantChange(event) {
    this.updateInventory();
  }

  updateInventory() {
    const variantId = this.variantSelector ? this.variantSelector.value : null;
    if (!variantId) return;

    const elementId = `inventory-${this.dataset.section}`;
    fetch(`${this.dataset.url}?variant=${variantId}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(elementId);
        const source = html.getElementById(elementId);
        if (source && destination) destination.innerHTML = source.innerHTML;
    });
  }
}

customElements.define('inventory-notice', InventoryNotice);